import axios from "@/api/axios";

const makePayment= (data) => {
    return axios
        .post('/admin/account/make-payment', {account: data})
        .then(response => response.data)
}

export default {
    makePayment,
}